<template>
  <div class="call-deviation-panel">
    <div class="call-deviation-panel__body">
      {{ $t('call-deviation.message', { number: deviation.to_username }) }}

      <Btn variant="bare" class="link--underline pdgl" @click="deleteDeviation">
        {{ $t('call-deviation.disable') }}
      </Btn>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    deviation() {
      return this.$store.state.voip.deviation;
    },
  },

  methods: {
    deleteDeviation() {
      this.$emit('delete');
    },
  },
};
</script>

<style lang="scss" scoped>
.call-deviation-panel {
  height: 6px;

  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  z-index: -2;

  background-color: $danger-500;
}

.call-deviation-panel__body {
  padding: 2px 30px 8px;

  position: absolute;
  top: 100%;
  right: 0;
  z-index: 0;

  font-weight: bold;
  color: white;

  background-color: $danger-500;
  border-bottom-left-radius: 40px;
}
</style>
